<template>
  <div class="content">
    <el-backtop target=".content" :visibility-height="100" :bottom="60"> </el-backtop>
    <el-dialog :visible.sync="originImageVisible" width="70%">
      <el-image :src="imageReformat(url)" fit="contain" ref="bigImage"></el-image>
      <!--      <img :src="url" object-fit="contain" ref="bigImage" @mousewheel="rollImg" />-->
    </el-dialog>
    <div>
      <navigation />
      <div class="container">
        <div style="padding: 0px 0px 20px 0px">
          <button @click="showTask = true" style="margin-left: 0px">任务列表</button>
        </div>
        <div class="task-info" v-if="showTask">
          <table width="100%" class="table">
            <thead>
              <tr>
                <th>任务ID</th>
                <th>任务名</th>
                <th>标注时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(task, index) of taskList" :key="`task${task.id}`">
                <td>
                  {{ task.id }}
                </td>
                <td>{{ task.name }}</td>
                <td>{{ new Date(task.updateAt).toLocaleDateString('chinese', { hour12: false }) }}</td>
                <td>
                  <span
                    @click="
                      queryTaskId = task.id;
                      showTask = false;
                      getIncorrectList();
                    "
                    :class="task.appealing || role !== 'admin' ? 'clickable' : 'disable'"
                    >查看</span
                  >
                  <span
                    v-if="['annatator', 'approver', 'approverTwo'].includes(role)"
                    style="margin-left: 10px"
                    :class="task.needPractice ? 'clickable' : 'disable'"
                    @click="startTaskExam(task.id)"
                    >错误练习</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="!showTask">
          <table width="100%" class="table">
            <thead>
              <tr>
                <th>框ID<br />(图片ID)</th>
                <th v-if="role !== 'admin' && role !== 'approverTwo'">
                  <select
                    class="clickable"
                    v-model="queryStatus"
                    @change="
                      pageIndex = 0;
                      getIncorrectList();
                    "
                    style="text-align-last: center;"
                  >
                    <option value="">状态</option>
                    <option value="1">错误</option>
                    <option value="2">申诉中</option>
                    <option value="3">申诉成功</option>
                    <option value="4">申诉失败</option>
                  </select>
                </th>
                <th>错误类型</th>
                <th>{{ role !== 'admin' ? '错误' : '申诉标注' }}</th>
                <th>{{ role !== 'admin' ? '正确' : '二审标注' }}</th>
                <th v-if="role !== 'approverTwo'" width="60px">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="c of incorrectList" :key="'incorrect' + c.id">
                <td>{{ c.id }}<br />({{ c.imageId }})</td>
                <td v-if="role !== 'admin' && role !== 'approverTwo'">
                  {{ appealRes(c) }}
                </td>
                <td>
                  {{ wrongType(c.iAnnotations, c.cAnnotations) }}
                </td>
                <td>
                  <div v-if="role === 'admin'">
                    <button @click="appealSucceed(c)" style="margin: 0px">正确</button>
                    <el-checkbox
                      v-model="c.leftChecked"
                      size="medium"
                      style="float: right"
                      @change="changeSelectedImage(c, 1)"
                    ></el-checkbox>
                  </div>
                  <AnnoPanel
                    :src="c.url"
                    ref="annopanel"
                    :annos="c.iAnnotations"
                    height="323"
                    :style="{ height: '323px', background: '#fafafa' }"
                    :mode="1"
                    scalable
                    maskColor="transparent"
                  ></AnnoPanel>
                </td>
                <td>
                  <div v-if="role === 'admin'">
                    <button @click="appealFail(c)" style="margin: 0px">正确</button>
                    <el-checkbox
                      v-model="c.rightChecked"
                      size="medium"
                      style="float: right"
                      @change="changeSelectedImage(c, 2)"
                    ></el-checkbox>
                  </div>
                  <AnnoPanel
                    :src="c.url"
                    ref="annopanel"
                    :annos="c.cAnnotations"
                    height="323"
                    :style="{ height: '323px', background: '#fafafa' }"
                    :mode="1"
                    scalable
                    maskColor="transparent"
                  ></AnnoPanel>
                </td>
                <td v-if="role !== 'admin' && role !== 'approverTwo'" width="80px">
                  <span
                    v-if="appealRes(c) === '错误'"
                    class="clickable"
                    @click="appeal(c)"
                    style="display: block;margin-bottom: 32px;"
                    >申诉</span
                  >
                  <span
                    v-if="appealRes(c) === '申诉中'"
                    class="clickable"
                    @click="appealCancel(c)"
                    style="display: block;"
                    >撤回申诉</span
                  >
                  <span
                    class="clickable"
                    @click="
                      url = c.url;
                      originImageVisible = true;
                    "
                    >查看原图</span
                  >
                </td>
                <td v-if="role === 'admin'" width="80px;">
                  <button style="margin: 0 0 20px 0;" @click="appealAllPass(c)">全部正确</button>
                  <router-link
                    style="display: block;margin-bottom: 24px"
                    class="clickable"
                    tag="a"
                    target="_blank"
                    :to="{
                      path: `/image/${c.imageId}`,
                      query: { tid: c.taskId, aid: c.id, imgid: c.imageId },
                    }"
                  >
                    重新标注</router-link
                  >
                  <span
                    class="clickable"
                    @click="
                      url = c.url;
                      originImageVisible = true;
                    "
                    >查看原图</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
          <pagination
            :page-size="pageSize"
            :page-index="pageIndex"
            :item-total="itemTotal"
            @changeindex="changePageIndex"
            @changesize="changePageSize"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/api.js';
import navigation from '@/components/navigation';
import AnnoPanel from '@/components/AnnoPanel.vue';
import pagination from '@/components/pagination';
import { taskTypeMap, resAnnoMap } from '@/config';
import { imageReformat } from '@/utils/util';

export default {
  name: 'IncorrectList',
  data() {
    return {
      pageSize: 20,
      pageIndex: 0,
      itemTotal: 0,
      incorrectList: [],
      classes: [],
      role: '',
      resAnnoMap: {},
      queryTaskId: 0,
      queryStatus: '',
      showTask: true,
      taskList: [],
      originImageVisible: false,
      url: '',
    };
  },
  components: {
    AnnoPanel,
    pagination,
    navigation,
  },
  mounted: function() {
    this.resAnnoMap = resAnnoMap;
    this.getTaskListForSalary();
    // this.getIncorrectList();
    this.role = this.$store.state.role;
    if (this.role === 'approverTwo') this.queryStatus = 4;
  },
  methods: {
    imageReformat,
    getTaskListForSalary() {
      api
        .getTaskListForSalary({ appeal: '1' })
        .then(res => {
          this.taskList = [];
          this.taskList = res.data;
          this.taskList.sort((a, b) => b.id - a.id);
          if (this.taskList.length > 0) this.queryTaskId = this.taskList[0].id;
        })
        .catch(() => {});
    },
    appealRes(anno) {
      if (this.role === 'annotator') return resAnnoMap[anno.resAnno];
      if (this.role === 'approver') return resAnnoMap[anno.resApprOne];
      if (this.role === 'approverTwo') return resAnnoMap[anno.resApprTwo];
    },
    wrongType(iAnnos, cAnnos) {
      if (iAnnos[0].cat.length === 0) return '漏框';
      if (cAnnos[0].cat.length === 0) return '多框';
      if (cAnnos[0].cat[0] !== iAnnos[0].cat[0]) return '类别错误';
      return '其他错误';
    },
    appeal(anno) {
      if (anno.approverThree !== 0) {
        this.$notify({
          group: 'foo',
          text: '该结果为申诉处理后的结果，无法再次申诉',
          type: 'custom-yellow',
          duration: 2000,
        });
        return;
      }
      if (!window.confirm('确认对标注结果进行申诉？')) return;
      api
        .appealIncorrect(anno.id)
        .then(() => {
          this.$notify({
            group: 'foo',
            text: '申诉已提交',
            type: 'custom-blue',
            duration: 1500,
          });
          this.getIncorrectList();
        })
        .catch();
    },
    appealCancel(anno) {
      api
        .appealIncorrectCancel(anno.id)
        .then(() => {
          this.$notify({
            group: 'foo',
            text: '申诉已撤回',
            type: 'custom-blue',
            duration: 1500,
          });
          this.getIncorrectList();
        })
        .catch();
    },
    appealSucceed(anno) {
      if (!window.confirm('确认此标注申诉成功？')) return;
      api
        .saveAnno({
          pageType: 'edit',
          taskId: anno.taskId,
          imageid: anno.imageId,
          annotationId: anno.id,
          points: anno.iAnnotations[0].data[0].length > 1 ? anno.iAnnotations[0].data : [],
          classIds: anno.iAnnotations[0].cat,
        })
        .then(() => {
          this.getIncorrectList();
        })
        .catch();
    },
    appealFail(anno) {
      if (!window.confirm('确认此标注申诉失败？')) return;
      api
        .saveAnno({
          pageType: 'edit',
          taskId: anno.taskId,
          imageid: anno.imageId,
          annotationId: anno.id,
          points: anno.cAnnotations[0].data[0].length > 1 ? anno.cAnnotations[0].data : [],
          classIds: anno.cAnnotations[0].cat,
        })
        .then(() => {
          this.getIncorrectList();
        })
        .catch();
    },
    toImageDetail(anno) {
      this.$router.push({
        path: `/image/${anno.imageId}`,
        query: { tid: anno.taskId, aid: anno.id, imgid: anno.imageId },
      });
    },
    changePageIndex: function(pi) {
      this.pageIndex = pi;
      this.getIncorrectList();
    },
    changePageSize: function(ps) {
      this.pageSize = parseInt(ps);
      this.pageIndex = 0;
      this.getIncorrectList();
    },
    getIncorrectList() {
      api
        .getIncorrectList({
          page: this.pageIndex,
          pagesize: this.pageSize,
          taskId: this.queryTaskId,
          status: this.queryStatus,
        })
        .then(res => {
          this.incorrectList = res.data.annotations;
          this.classes = res.data.classes;
          this.incorrectList.forEach(v => {
            if (this.role === 'annotator') {
              v.iAnnotations = [
                {
                  data: v.annoPoints.length !== 0 ? v.annoPoints : [[[]]],
                  cat: v.annoCat,
                  type: taskTypeMap[v.taskTypeId],
                  title: this.classes.find(c => c.id === v.annoCat[0])
                    ? this.classes.find(c => c.id === v.annoCat[0]).name
                    : '',
                },
              ];
            } else if (this.role === 'approver') {
              v.iAnnotations = [
                {
                  data: v.apprOnePoints.length !== 0 ? v.apprOnePoints : [[[]]],
                  cat: v.apprOneCat,
                  type: taskTypeMap[v.taskTypeId],
                  title: this.classes.find(c => c.id === v.apprOneCat[0])
                    ? this.classes.find(c => c.id === v.apprOneCat[0]).name
                    : '',
                },
              ];
            } else if (this.role === 'approverTwo') {
              v.iAnnotations = [
                {
                  data: v.apprTwoPoints.length !== 0 ? v.apprTwoPoints : [[[]]],
                  cat: v.apprTwoCat,
                  type: taskTypeMap[v.taskTypeId],
                  title: this.classes.find(c => c.id === v.apprTwoCat[0])
                    ? this.classes.find(c => c.id === v.apprTwoCat[0]).name
                    : '',
                },
              ];
            } else if (this.role === 'admin') {
              if (v.resApprOne == 2)
                v.iAnnotations = [
                  {
                    data: v.apprOnePoints.length !== 0 ? v.apprOnePoints : [[[]]],
                    cat: v.apprOneCat,
                    type: taskTypeMap[v.taskTypeId],
                    title: this.classes.find(c => c.id === v.apprOneCat[0])
                      ? this.classes.find(c => c.id === v.apprOneCat[0]).name
                      : '',
                  },
                ];
              else if (v.resAnno == 2)
                v.iAnnotations = [
                  {
                    data: v.annoPoints.length !== 0 ? v.annoPoints : [[[]]],
                    cat: v.annoCat,
                    type: taskTypeMap[v.taskTypeId],
                    title: this.classes.find(c => c.id === v.annoCat[0])
                      ? this.classes.find(c => c.id === v.annoCat[0]).name
                      : '',
                  },
                ];
            }
            if (v.approverThree !== 0)
              v.cAnnotations = [
                {
                  data: v.apprThreePoints.length !== 0 ? v.apprThreePoints : [[[]]],
                  cat: v.apprThreeCat,
                  type: taskTypeMap[v.taskTypeId],
                  title: this.classes.find(c => c.id === v.apprThreeCat[0])
                    ? this.classes.find(c => c.id === v.apprThreeCat[0]).name
                    : '',
                },
              ];
            else
              v.cAnnotations = [
                {
                  data: v.apprTwoPoints.length !== 0 ? v.apprTwoPoints : [[[]]],
                  cat: v.apprTwoCat,
                  type: taskTypeMap[v.taskTypeId],
                  title: this.classes.find(c => c.id === v.apprTwoCat[0])
                    ? this.classes.find(c => c.id === v.apprTwoCat[0]).name
                    : '',
                },
              ];
            // 处理申诉成功情况
            if (this.role === 'annotator' && v.resAnno == '3') {
              v.iAnnotations = [
                {
                  data: v.apprOnePoints.length !== 0 ? v.apprOnePoints : [[[]]],
                  cat: v.apprOneCat,
                  type: taskTypeMap[v.taskTypeId],
                  title: this.classes.find(c => c.id === v.apprOneCat[0])
                    ? this.classes.find(c => c.id === v.apprOneCat[0]).name
                    : '',
                },
              ];
            }
            if (this.role === 'approver' && v.resApprOne === '3') {
              v.iAnnotations = [
                {
                  data: v.apprTwoPoints.length !== 0 ? v.apprTwoPoints : [[[]]],
                  cat: v.apprTwoCat,
                  type: taskTypeMap[v.taskTypeId],
                  title: this.classes.find(c => c.id === v.apprTwoCat[0])
                    ? this.classes.find(c => c.id === v.apprTwoCat[0]).name
                    : '',
                },
              ];
            }
          });
          this.itemTotal = res.data.annotationsCount;
        })
        .catch(err => window.console.log(err));
    },
    changeSelectedImage(item, position) {
      if (position === 1) {
        item.rightChecked = !item.leftChecked;
      } else {
        item.leftChecked = !item.rightChecked;
      }
    },
    appealAllPass(anno) {
      if (!window.confirm('确认通过所有申诉标注？')) return;
      if (!anno.leftChecked && !anno.rightChecked) {
        this.$message({ message: '请点击图片右上角方框选择一个需要保存的标注结果', type: 'warning' });
        return;
      }
      if (anno.leftChecked) {
        api
          .saveAnno({
            pageType: 'edit',
            taskId: anno.taskId,
            imageid: anno.imageId,
            annotationId: anno.id,
            points: anno.iAnnotations[0].data[0].length > 1 ? anno.iAnnotations[0].data : [],
            classIds: anno.iAnnotations[0].cat,
            appealPassAll: 1,
          })
          .then(() => {
            this.getIncorrectList();
          })
          .catch();
      } else if (anno.rightChecked) {
        api
          .saveAnno({
            pageType: 'edit',
            taskId: anno.taskId,
            imageid: anno.imageId,
            annotationId: anno.id,
            points: anno.cAnnotations[0].data[0].length > 1 ? anno.cAnnotations[0].data : [],
            classIds: anno.cAnnotations[0].cat,
            appealPassAll: 1,
          })
          .then(() => {
            this.getIncorrectList();
          })
          .catch();
      }
    },
    // 开始任务中错误图片练习 对应examId -1
    startTaskExam(tid) {
      if (!['annotator', 'approver', 'approverTwo'].includes(this.role)) return;
      this.$router.push({ path: `/exam/-1/annotate`, query: { tid } });
    },
    // 鼠标滚动放大缩小图片
    rollImg() {
      /* 获取当前页面的缩放比
            若未设置zoom缩放比，则为默认100%，即1，原图大小
        */
      let zoom = parseInt(this.$refs.bigImage.style.zoom) || 100;
      /* event.wheelDelta 获取滚轮滚动值并将滚动值叠加给缩放比zoom
            wheelDelta统一为±120，其中正数表示为向上滚动，负数表示向下滚动
        */
      zoom += event.wheelDelta / 12;
      /* 最小范围 和 最大范围 的图片缩放尺度 */
      if (zoom >= 30 && zoom < 150) {
        this.$refs.bigImage.style.zoom = zoom + '%';
      }
      return false;
    },
  },
};
</script>

<style scoped>
.disable {
  color: #bbbbbb;
}
a {
  color: #5d89c0;
  text-decoration: none;
  display: inline-block;
  margin: 2px 5px;
  cursor: pointer;
}
p {
  display: inline-block;
  margin: 0px 6px;
  vertical-align: top;
}
section {
  display: inline-block;
  width: max-content;
  vertical-align: top;
  padding: 0px 10px;
  color: #595959;
}
section span {
  display: block;
  padding-bottom: 5px;
}
select {
  border: none;
  font-size: 14px;
  font-weight: bold;
  appearance: none;
  outline: none;
}
span.class-info {
  position: relative;
  text-decoration: underline;
  color: #5d89c0;
}
span.class-info:hover + div.class-info {
  visibility: visible;
}
div.class-info {
  background-color: #ffffff;
  padding: 16px 2px;
  width: max-content;
  position: absolute;
  visibility: hidden;
  z-index: 999;
  border: 1px solid #eeeeee;
  color: #5d89c0;
  box-shadow: 0px 2px 4px 0px rgba(221, 221, 221, 1);
  border-radius: 0px 0px 5px 5px;
}
table {
  border-collapse: collapse;
  margin: 0px;
  text-align: left;
  font-size: 14px;
}
table th,
table td {
  margin-left: 24px;
  border: 1px solid #cccccc;
  min-width: 60px;
  text-align: center;
}
table thead tr {
  height: 54px;
  font-weight: 500;
  background: #fafafa;
}
table tr {
  border-bottom: 1px solid #eeeeee;
  height: 54px;
}
table tbody {
  color: #595959;
}
.content {
  height: 100vh;
  min-height: 800px;
  overflow-x: hidden;
  scrollbar-width: none;
}
.content::-webkit-scrollbar {
  display: none;
}
.container {
  padding: 36px 50px 0px 301px;
  text-align: left;
  min-width: 1440px;
  height: 100%;
  overflow: auto;
  /*position: absolute;*/
  /*left: 0px;*/
  /*top: 0px;*/
  width: 100%;
  box-sizing: border-box;
}
</style>
